import { EventTitleEnum, LanguageCodeEnum } from '../../../../../common/enums/common.enum';
import * as Yup from 'yup';

const localizedTitleSchema = (requiredMsg: string) =>
  Yup.object().shape(
    Object.fromEntries(
      Object.values(LanguageCodeEnum).map(lang => [
        lang,
        lang === LanguageCodeEnum.ENG ? Yup.string().required(requiredMsg) : Yup.string().nullable()
      ])
    )
  );

const eventConfigValidationSchema = Yup.object().shape({
  eventConfigs: Yup.object().shape(
    Object.fromEntries(
      Object.values(EventTitleEnum).map(mainEvent => [
        mainEvent,
        Yup.object().shape({
          childEvents: Yup.array().of(
            Yup.object().shape({
              title: localizedTitleSchema('Child event name in English is required'),
              icon: Yup.string().test('icon-required', 'Icon is required for TOILET child events', function (value) {
                if (mainEvent === EventTitleEnum.TOILET && !value) return false;
                return true;
              })
            })
          ),
          options: Yup.array()
            .of(
              Yup.object().shape({
                title: localizedTitleSchema('Option title in English is required'),
                icon: Yup.string().test('icon-required', 'Option icon is required', function (value) {
                  if (mainEvent !== EventTitleEnum.TOILET && !value) return false;
                  return true;
                }),
                value: Yup.number().required('Option value is required')
              })
            )
            .min(2, 'At least 2 options required')
        })
      ])
    )
  )
});

export const getStepSchemas = (singleGroupMode: boolean) => {
  return [
    Yup.object({
      selectedGroups: singleGroupMode ? Yup.array().nullable() : Yup.array().min(1, 'Select at least one group'),
      selectedEvents: Yup.array().min(1, 'Select at least one event')
    }),
    eventConfigValidationSchema,
    Yup.object()
  ];
};
